import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

function Footer() {
    const location = useLocation();

    const handleAboutClick = (e) => {
        if (location.pathname === '/') {
            e.preventDefault();
            const element = document.getElementById('about');
            if (element) {
                const headerOffset = 100; // Adjust for header
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        } else {
            window.scrollTo(0, 0); // Reset scroll when navigating from another page
        }
    };

    return (
        <footer className="footer-modern">
            {/* CTA Section */}
            <div className="footer-cta">
                <div className="container">
                    <div className="footer-cta-content">
                        <div className="footer-cta-left">
                            <h2>Transform Your Brand with Expert Signage & Graphics Solutions!</h2>
                        </div>
                        <div className="footer-cta-right">
                            <p>The team at Rainbow Craft ensures top-quality printing and branding solutions, helping your business stand out effortlessly. Need urgent assistance? Call us now!</p>
                            <a href="tel:+971569004913" className="footer-phone">+971 50 860 4485</a>
                            <Link to="/contact" className="footer-cta-btn" onClick={() => window.scrollTo(0, 0)}>
                                Get in Touch <span>→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer Content */}
            <div className="footer-main">
                <div className="container">
                    <div className="footer-grid">
                        {/* Contact Info */}
                        <div className="footer-column">
                            <h3>Contact Us</h3>
                            <div className="footer-info-item">
                                <FaMapMarkerAlt />
                                <span>Musaffah - Sanaya M/38<br />Abu Dhabi - U.A.E</span>
                            </div>
                            <div className="footer-info-item">
                                <FaPhone />
                                <a href="tel:+971569004913">+971 50 860 4485</a>
                            </div>
                            <div className="footer-info-item">
                                <FaEnvelope />
                                <a href="mailto:sales@rainbowcraft.ae">sales@rainbowcraft.ae</a>
                            </div>
                        </div>

                        {/* Our Services */}
                        <div className="footer-column">
                            <h3>Our Services</h3>
                            <ul className="footer-links">
                                <li><Link to="/services" onClick={() => window.scrollTo(0, 0)}>Offset & Screen Printing</Link></li>
                                <li><Link to="/services" onClick={() => window.scrollTo(0, 0)}>Internal, External & Road Signages</Link></li>
                                <li><Link to="/services" onClick={() => window.scrollTo(0, 0)}>Wide Format Printing & Branding</Link></li>
                            </ul>
                        </div>

                        {/* Social Links */}
                        <div className="footer-column">
                            <h3>Follow Us</h3>
                            <div className="footer-social">
                                <a href="https://www.facebook.com/profile.php?id=61585363281245" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <FaFacebook /> Facebook
                                </a>
                                <a href="https://www.instagram.com/rainbowcraftllc.ae/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <FaInstagram /> Instagram
                                </a>
                                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                    <FaLinkedin /> LinkedIn
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="footer-column">
                            <h3>Quick Links</h3>
                            <ul className="footer-links">
                                <li><Link to="/" onClick={() => window.scrollTo(0, 0)}>Our Blog</Link></li>
                                {location.pathname === '/' ? (
                                    <li><a href="#about" onClick={handleAboutClick}>About Us</a></li>
                                ) : (
                                    <li><Link to="/#about" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
                                )}
                                <li><Link to="/projects" onClick={() => window.scrollTo(0, 0)}>Our Works</Link></li>
                                <li><Link to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link></li>
                            </ul>
                        </div>


                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="container">
                    <p>Copyright © 2026 Rainbow Craft Graphics Design LLC - Abu Dhabi | Powered by Rainbow Craft Graphics Design LLC - Abu Dhabi</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
